// extracted by mini-css-extract-plugin
export default {"container":"LogIn_container__DYtNQ","submit":"LogIn_submit__ofvSD","cancel":"LogIn_cancel__k761i","h1":"LogIn_h1__52oJj"};